/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import { Button } from '@components/v2/Button';
import ClickAwayListener from 'react-click-away-listener';
function Tags({ tagsList, attributeName, tagsForSelect, showHeader = true, onTagsChange }) {
    const [tags, setTags] = useState(tagsList);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const anchor = useRef(null);
    const handleAddTag = (value) => {
        setDropdownOpen(false);
        if (!tags.includes(value)) {
            const newTags = [...tags, value];
            setTags(newTags);
            onTagsChange(newTags);
        }
    };
    const handleRemoveTag = (value) => {
        const newTags = tags.filter((tag) => tag !== value);
        setTags(newTags);
        onTagsChange(newTags);
    };
    return (React.createElement("div", { className: "form__set--horizontal--tags" },
        showHeader && React.createElement("label", null,
            translate('tags', { namespace: 'generic' }),
            ":"),
        tags.map((tag) => (React.createElement(Tag, { key: tag, value: tag, onRemoveTag: handleRemoveTag, attributeName: attributeName }))),
        React.createElement(Button, { ref: anchor, variant: "secondary", "aria-label": "Click", onClick: (e) => {
                e.stopPropagation();
                setDropdownOpen(!dropdownOpen);
            } },
            React.createElement("i", { className: "fa-solid fa-plus" })),
        React.createElement(Popup, { anchor: anchor.current, show: dropdownOpen },
            React.createElement(TagDropdown, { tagsForSelect: tagsForSelect.filter((tag) => !tags.includes(tag.label)), onAddTag: handleAddTag, onClosePopup: () => setDropdownOpen(false) }))));
}
function TagDropdown({ onAddTag, onClosePopup, tagsForSelect }) {
    const searchRef = useRef(null);
    const [availableTags, setAvailableTags] = useState([]);
    const [filteredTags, setFilteredTags] = useState([]);
    useEffect(() => {
        var _a;
        (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setAvailableTags(tagsForSelect.map((tag) => tag.label));
        setFilteredTags(tagsForSelect.map((tag) => tag.label));
    }, [tagsForSelect]);
    const onHandleKeyUp = (event) => {
        if (event.key === 'Enter') {
            onAddTag(event.target.value);
        }
        else {
            setFilteredTags(availableTags.filter((tag) => tag.toLowerCase().startsWith(event.target.value.toLowerCase())));
        }
    };
    return (React.createElement(ClickAwayListener, { onClickAway: onClosePopup },
        React.createElement("div", null,
            React.createElement("div", { className: "qmb-input--blank" },
                React.createElement("input", { ref: searchRef, onKeyUp: onHandleKeyUp })),
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', maxHeight: '120px', overflowY: 'auto' } },
                filteredTags.length === 0 && (React.createElement(NoMatch, { onHandleClick: () => {
                        var _a, _b;
                        if ((_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.value.trim()) {
                            onAddTag((_b = searchRef.current) === null || _b === void 0 ? void 0 : _b.value);
                        }
                    } })),
                filteredTags.length > 0 &&
                    filteredTags.map((tag) => React.createElement(DropdownItem, { key: tag, value: tag, onHandleClick: onAddTag }))))));
}
function DropdownItem({ value, onHandleClick }) {
    return (React.createElement("button", { className: "qmb-control", type: "button", onClick: () => onHandleClick(value) }, value));
}
function NoMatch({ onHandleClick }) {
    return (React.createElement("button", { className: "qmb-control", type: "button", onClick: onHandleClick },
        translate('create_new_tag', { namespace: 'generic' }),
        React.createElement("i", { className: "fa-light fa-turn-down-left" })));
}
function Tag({ value, onRemoveTag, attributeName }) {
    return (React.createElement("span", { className: "qmb-tag" },
        value,
        React.createElement("input", { type: "hidden", name: attributeName, value: value }),
        React.createElement("button", { className: "qmb-control--icon fa-light fa-xmark", type: "button", "aria-label": "Click", onClick: () => {
                onRemoveTag(value);
            } })));
}
export default Tags;
